import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { Trans, withNamespaces } from 'react-i18next';

import Heading from 'components/Heading';
import Paragraph from 'components/Paragraph';
import { Center, MainWrapper } from 'legacyComponents/styled/lib';

import {
  Table as BaseTable,
  THead,
  Th as BaseTh,
  Td as BaseTd,
} from 'apps/payment/styles';
import styled from 'styled-components';
import { media as oldMedia } from 'legacyComponents/styled/styleUtils';
import { media } from 'styles/utils';

function AllTicks() {
  return (
    <>
      <TdTick />
      <TdTick color='#172cff' />
      <TdTick color='#ffcd00' />
      <TdTick color='#ffffff' stroke />
    </>
  );
}

@withNamespaces()
@inject('routerStore')
@observer
export class Features extends React.Component {
  render() {
    return (
      <MainWrapper marginTop='40px' marginBottom='90px'>
        <Center>
          <Heading level='2' size='xlarge' margin='default 0 large 0'>
            <Trans>Comparing features.</Trans>
          </Heading>
        </Center>
        <Table first>
          <THead>
            <tr>
              <Th />
              <Th center>
                <Paragraph>
                  <Trans>Free</Trans>
                </Paragraph>
                <Heading level='3'>
                  <Trans>€0 / month</Trans>
                </Heading>
              </Th>
              <Th center>
                <Paragraph>
                  <Trans>Individual</Trans>
                </Paragraph>
                <Heading level='3'>
                  <Trans>€7 / month</Trans>
                </Heading>
              </Th>
              <Th center>
                <Paragraph>
                  <Trans>Team</Trans>
                </Paragraph>
                <Heading level='3'>
                  <Trans>€25 / month</Trans>
                </Heading>
              </Th>
              <Th center contact>
                <Paragraph>
                  <Trans>Custom</Trans>
                </Paragraph>
                <Heading level='3'>
                  <Trans>Contact us</Trans>
                </Heading>
              </Th>
            </tr>
          </THead>
          <tbody>
            <tr>
              <Td category>
                <Trans>Product Data Management</Trans>
              </Td>
            </tr>
            <tr>
              <Td feature>
                <Trans>Public projects</Trans>
              </Td>
              <Td>
                <Trans>Unlimited</Trans>
              </Td>
              <Td>
                <Trans>Unlimited</Trans>
              </Td>
              <Td>
                <Trans>Unlimited</Trans>
              </Td>
              <Td>
                <Trans>Unlimited</Trans>
              </Td>
            </tr>
            <tr>
              <Td feature>
                <Trans>Private projects</Trans>
              </Td>
              <Td>0</Td>
              <Td>
                <Trans>Unlimited</Trans>
              </Td>
              <Td>
                <Trans>Unlimited</Trans>
              </Td>
              <Td>
                <Trans>Custom</Trans>
              </Td>
            </tr>
            <tr>
              <Td category>
                <Trans>Cloud Storage</Trans>
              </Td>
            </tr>
            <tr>
              <Td feature>
                <Trans>Per user</Trans>
              </Td>
              <Td>
                <Trans>3GB</Trans>
              </Td>
              <Td>
                <Trans>Unlimited</Trans>
              </Td>
              <Td>
                <Trans>Unlimited</Trans>
              </Td>
              <Td>
                <Trans>Unlimited</Trans>
              </Td>
            </tr>
            <tr>
              <Td category>
                <Trans>Collaboration</Trans>
              </Td>
            </tr>
            <tr>
              <Td feature>
                <Trans>Public collaborators</Trans>
              </Td>
              <Td>
                <Trans>Unlimited</Trans>
              </Td>
              <Td>
                <Trans>Unlimited</Trans>
              </Td>
              <Td>
                <Trans>Unlimited</Trans>
              </Td>
              <Td>
                <Trans>Unlimited</Trans>
              </Td>
            </tr>
            <tr>
              <Td feature>
                <Trans>Private collaborators</Trans>
              </Td>
              <Td>
                <Trans>0</Trans>
              </Td>
              <Td>
                <Trans>Includes 3</Trans>
              </Td>
              <Td>
                <Trans>Starts at 5</Trans>
              </Td>
              <Td>
                <Trans>Custom</Trans>
              </Td>
            </tr>
            <tr>
              <Td category>
                <Trans>Product Development Workflow</Trans>
              </Td>
            </tr>
            <tr>
              <Td feature>
                <Trans>Product file upload</Trans>
              </Td>
              <AllTicks />
            </tr>
            <tr>
              <Td feature>
                <Trans>CAD/CAE file viewer</Trans>
              </Td>
              <AllTicks />
            </tr>
            <tr>
              <Td feature>
                <Trans>Multi-part assembly inspector & exploder</Trans>
              </Td>
              <AllTicks />
            </tr>
            <tr>
              <Td feature>
                <Trans>Design review & shareable links</Trans>
              </Td>
              <AllTicks />
            </tr>
            <tr>
              <Td feature>
                <Trans>Documentation editor & publisher</Trans>
              </Td>
              <AllTicks />
            </tr>
            <tr>
              <Td feature>
                <Trans>Change log & notifications</Trans>
              </Td>
              <AllTicks />
            </tr>
            <tr>
              <Td feature>
                <Trans>Task assignment & discussion</Trans>
              </Td>
              <Td />
              <Td />
              <TdTick color='#ffcd00' />
              <TdTick color='#fff' stroke />
            </tr>
            <tr>
              <Td feature>
                <Trans>Stakeholder feedback management</Trans>
              </Td>
              <Td />
              <Td />
              <TdTick color='#ffcd00' />
              <TdTick color='#fff' stroke />
            </tr>
            <tr>
              <Td category>
                <Trans>Security and User Management</Trans>
              </Td>
            </tr>
            <tr>
              <Td feature>
                <Trans>Activity notifications & security alerts</Trans>
              </Td>
              <AllTicks />
            </tr>
            <tr>
              <Td feature>
                <Trans>File Recovery & distributed data backup</Trans>
              </Td>
              <AllTicks />
            </tr>
            <tr>
              <Td feature>
                <Trans>No data format lock-in</Trans>
              </Td>
              <AllTicks />
            </tr>
            <tr>
              <Td feature>
                <Trans>Priority customer support</Trans>
              </Td>
              <Td />
              <TdTick color='#172cff' />
              <TdTick color='#ffcd00' />
              <TdTick color='#fff' stroke />
            </tr>
            <tr>
              <Td feature>
                <Trans>Role based permissions</Trans>
              </Td>
              <Td />
              <TdTick color='#172cff' />
              <TdTick color='#ffcd00' />
              <TdTick color='#fff' stroke />
            </tr>
            <tr>
              <Td feature>
                <Trans>Organisation and team management</Trans>
              </Td>
              <Td />
              <Td />
              <TdTick color='#ffcd00' />
              <TdTick color='#fff' stroke />
            </tr>
            <tr>
              <Td feature>
                <Trans>Admin role inheritance</Trans>
              </Td>
              <Td />
              <Td />
              <TdTick color='#ffcd00' />
              <TdTick color='#fff' stroke />
            </tr>
            <tr>
              <Td feature>
                <Trans>Audit log</Trans>
              </Td>
              <Td />
              <Td />
              <TdTick color='#ffcd00' />
              <TdTick color='#fff' stroke />
            </tr>
            <tr>
              <Td feature>
                <Trans>OAuth single-sign on (SSO)</Trans>
              </Td>
              <Td />
              <Td />
              <Td />
              <TdTick color='#fff' stroke />
            </tr>
            <tr>
              <Td category>
                <Trans>Social Features</Trans>
              </Td>
            </tr>
            <tr>
              <Td feature>
                <Trans>Public profiles</Trans>
              </Td>
              <AllTicks />
            </tr>
            <tr>
              <Td feature>
                <Trans>Stories</Trans>
              </Td>
              <AllTicks />
            </tr>
            <tr>
              <Td feature>
                <Trans>Social reputation & following</Trans>
              </Td>
              <AllTicks />
            </tr>
            <tr>
              <Td feature>
                <Trans>Activity feeds & notifications</Trans>
              </Td>
              <AllTicks />
            </tr>
            <tr>
              <Td feature>
                <Trans>Forum</Trans>
              </Td>
              <Td>
                <Trans>Organisations</Trans>
              </Td>
              <Td />
              <TdTick color='#ffcd00' />
              <TdTick color='#fff' stroke />
            </tr>
          </tbody>
        </Table>
      </MainWrapper>
    );
  }
}

Features.propTypes = {
  t: PropTypes.func,
};

const Table = styled(BaseTable)`
  margin: ${props => (props.first ? '30px 0px' : '20px 0px')};
  ${oldMedia.xs`
    display: block;
    overflow-x: auto;
  `};
`;

const Th = styled(BaseTh)`
  padding: 20px;
  > p {
    font-size: 0.9em;
  }
  > p:not(:first-of-type) {
    font-size: 0.75em;
    color: ${props => props.theme.color.wfGrey500};
  }
  > h3 {
    margin: 10px 0px;
  }
`;

const Td = styled(BaseTd)`
  /* TODO: temporarily fix for TD category, full refactorization for table component needed */
  height: ${props => (props.category ? '60px' : '40px')};
  padding: ${props => props.empty && props.theme.spacing.small};
  padding-left: ${props =>
    props.feature ? '4vw' : props.category ? '2vw' : null};
  padding-top: ${props => props.category && props.theme.spacing.default};
  font-size: ${props =>
    props.category
      ? props.theme.font.size.default
      : props.theme.font.size.small};
  font-weight: ${props => props.category && props.theme.font.weight.xbold};
  border-bottom: ${props => props.empty && 'none'};
  text-align: ${props => (props.feature || props.category ? 'left' : 'center')};
  vertical-align: middle;
  ${oldMedia.xs`
    min-width: 100px;
  `};
`;

const CircleCheck = styled.svg`
  width: 18px;
  height: 18px;
  display: block;
  margin: 0 auto;
  /** Media queries */
  ${media.medium`
    width: 24px;
    height: 24px;
  `}
`;

function TdTick({ color, stroke }) {
  return (
    <Td>
      <CircleCheck viewBox='0 0 25 25'>
        <title>Included</title>
        <circle
          vectorEffect='non-scaling-stroke'
          cx='50%'
          cy='50%'
          r='12'
          fill={color || '#000'}
          strokeWidth='1'
          stroke={stroke ? '#000' : color}
        />
      </CircleCheck>
    </Td>
  );
}

TdTick.propTypes = {
  color: PropTypes.string,
  stroke: PropTypes.bool,
};
